import { useState } from 'react';

import { prepareFilter } from 'libs/common';
import { getVehicleClasses, getCategories } from 'services/types';
import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { RideGrid } from './grid';
import Filter from './filter';

const initialItems = {};
const initialSortParams = [{ field_name: 'timestamp', direction: 'desc' }];

export const Ride = (props) => {
  const { isPlate } = props;
  const [items, setItems] = useState(initialItems);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('rides', initialSortParams);

  // classes
  const vehicleClasses = getVehicleClasses();
  const categories = getCategories();

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    const intFields = ['vehicle_class'];
    const boolFields = ['result', 'mean_is_blocked'];
    const toggleFields = ['is_suspicious'];
    const addParams = {};
    if (isPlate) {
      addParams.mean_type = 'vehicle_plate';
    }
    return prepareFilter(data, addParams, { boolFields, intFields, toggleFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  // return null;

  return (
    <Controller
      {...props}
      {...gridParams}
      {...gridActions}
      locationState={props.location?.state}
      type="passage"
      filterName="passageFilter"
      grid={RideGrid}
      gridFilter={Filter}
      getRequestParams={prepareParams}
      // additional data
      vehicleClasses={vehicleClasses}
      categories={categories}
    />
  );
};
